@import '../../../theme.scss';

verdocs-help-icon {
  font-family: $verdocs-primary-font;
  display: inline-block;
  opacity: 0.3;
  position: relative;

  &:hover {
    opacity: 1;
  }

  .icon {
    display: inline-block;
  }

  .tooltip {
    display: none;
    min-width: 200px;
    box-shadow: 0 0 10px 1px #999999;
    background: #ffffff;
    color: $label-color;
    max-width: 240px;
    font-weight: 500;
    position: absolute;
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 4px;
    z-index: 10005;

    .arrow,
    .arrow::before {
      position: absolute;
      width: 8px;
      height: 8px;
      background: inherit;
    }

    .arrow {
      visibility: hidden;
      top: -4px;
    }

    .arrow::before {
      visibility: visible;
      content: '';
      transform: rotate(45deg);
    }

    &[data-show] {
      display: block;
    }

    &[data-popper-placement^='top'] > .arrow {
      bottom: -4px;
    }

    &[data-popper-placement^='bottom'] > .arrow {
      top: -4px;
    }

    &[data-popper-placement^='left'] > .arrow {
      right: -4px;
    }

    &[data-popper-placement^='right'] > .arrow {
      left: -4px;
    }
  }
}
